import { PercentPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { MonitoramentoPrecosFiltroService } from './monitoramento-precos';
import { MonitoramentoPrecosService } from './monitoramento-precos.service';

declare var $: any;

@Component({
  selector: 'app-monitoramento-precos',
  templateUrl: './monitoramento-precos.component.html',
  styleUrls: ['./monitoramento-precos.component.scss']
})
export class MonitoramentoPrecosComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  origem = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  carregando: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;

  percentual: any[] = [];

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Number": "businessIntelligence.monitoramentoPrecos.dealerCod",
    "Dealer Name": "businessIntelligence.monitoramentoPrecos.dealerName",
    "Data": "businessIntelligence.monitoramentoPrecos.dataEmissao",
    "PartNumber": "businessIntelligence.monitoramentoPrecos.partNumber",
    "Descrição": "businessIntelligence.monitoramentoPrecos.descricaoItem",
    "Quantidade": "businessIntelligence.monitoramentoPrecos.quantidade",
    "Valor de Venda": "businessIntelligence.monitoramentoPrecos.valorVenda",
    "Origem": "businessIntelligence.monitoramentoPrecos.origem",
    "tipoOs": "businessIntelligence.monitoramentoPrecos.tiposervicoOrdem",
    "numeroOs": "businessIntelligence.monitoramentoPrecos.numeroOs",
    "Km": "businessIntelligence.monitoramentoPrecos.km",
    "numeroChassi": "businessIntelligence.monitoramentoPrecos.numeroChassi",
    "Descrição do Modelo": "businessIntelligence.monitoramentoPrecos.descModelo",
    "CPF/CNPJ": "businessIntelligence.monitoramentoPrecos.documento",
    "Inventário Final Qtd.": "businessIntelligence.monitoramentoPrecos.inventFinalQtd",
  }

  constructor(private service: MonitoramentoPrecosService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: MonitoramentoPrecosFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder,
    private percent: PercentPipe) {
    this.filtros = {};
    this.nomeModulo = 'monitoramento-precos';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      origem: [''],
      partNumber: [''],
      documento: [''],
      percentual: [''],
      original: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.preencherOrigem();
    this.preencherPercentual();

    this.carregando = true;

    this.cols = [
      { field: 'codDealer', header: 'businessIntelligence.monitoramentoPrecos.dealerCod' },
      { field: 'nome', header: 'businessIntelligence.monitoramentoPrecos.dealerName' },
      { field: 'data', header: 'businessIntelligence.monitoramentoPrecos.dataEmissao' },
      { field: 'partNumber', header: 'businessIntelligence.monitoramentoPrecos.partNumber' },
      { field: 'descricaoItem', header: 'businessIntelligence.monitoramentoPrecos.descricaoItem' },
      { field: 'quantidade', header: 'businessIntelligence.monitoramentoPrecos.quantidade' },
      { field: 'valorVenda', header: 'businessIntelligence.monitoramentoPrecos.valorVenda' },
      { field: 'precoPublico', header: 'businessIntelligence.monitoramentoPrecos.precoPublico' },
      { field: 'percentualOverPricing', header: 'businessIntelligence.monitoramentoPrecos.percentualOverPricing', type: this.percent, arg1: '1.2-2' },
      { field: 'numeroVenda', header: 'businessIntelligence.monitoramentoPrecos.numeroVenda' },
      { field: 'origem', header: 'businessIntelligence.monitoramentoPrecos.origem' },
      { field: 'tipoOs', header: 'businessIntelligence.monitoramentoPrecos.tiposervicoOrdem' },
      { field: 'numeroOs', header: 'businessIntelligence.monitoramentoPrecos.numeroOs' },
      { field: 'km', header: 'businessIntelligence.monitoramentoPrecos.km' },
      { field: 'numeroChassi', header: 'businessIntelligence.monitoramentoPrecos.numeroChassi' },
      { field: 'descModelo', header: 'businessIntelligence.monitoramentoPrecos.descModelo' },
      { field: 'documento', header: 'businessIntelligence.monitoramentoPrecos.documento' },
      { field: 'nomeCliente', header: 'businessIntelligence.monitoramentoPrecos.cliente' },
      { field: 'email', header: 'businessIntelligence.monitoramentoPrecos.email' },
      { field: 'ddd', header: 'businessIntelligence.monitoramentoPrecos.ddd' },
      { field: 'telefone', header: 'businessIntelligence.monitoramentoPrecos.telefone' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherOrigem() {
    this.origem = [
      { nome: 'A&L (Clothing)', valor: "1" },
      { nome: 'Balcão', valor: "2" },
      { nome: 'Oficina', valor: "3" },
      { nome: 'Outros', valor: "4" }
    ];
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.origem.value,
      this.f.partNumber.value, this.f.documento.value, this.f.percentual.value, this.f.original.value).subscribe(dados => {
        this.dealersDados = dados.precos;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");

          const precoPublico = this.conversaoLibraConverte.conversaoLibra(element.precoPublico, null, null);
          const precoPublicoFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(precoPublico);
          element.precoPublico = precoPublicoFormatado.replace("R$", "");

          element.data = element.data.substring(0, 10);
        });

        this.carregando = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.origem.value
      || this.f.partNumber.value
      || this.f.documento.value
      || this.f.original.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.documento.setValue('');
    this.f.origem.setValue('');
    this.f.partNumber.setValue('');
    this.f.percentual.setValue('');
    this.f.original.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.monitoramentoPrecos.dealerCod") {
      return this.translate.currentLang == "br" ? "Cod. Dealer" : "Dealer Code";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.dealerName") {
      return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.dataEmissao") {
      return this.translate.currentLang == "br" ? "Data" : "Date";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.partNumber") {
      return this.translate.currentLang == "br" ? "PartNumber" : "partNumber";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.descricaoItem") {
      return this.translate.currentLang == "br" ? "Descrição" : "Description";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.quantidade") {
      return this.translate.currentLang == "br" ? "Quantidade" : "Amount";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.valorVenda") {
      return this.translate.currentLang == "br" ? "Valor de Venda" : "Sale Value";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.precoPublico") {
      return this.translate.currentLang == "br" ? "Preço Público" : "Public Price";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.percentualOverPricing") {
      return "OverPricing";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.numeroVenda") {
      return this.translate.currentLang == "br" ? "NF Venda" : "NF Sale";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.origem") {
      return this.translate.currentLang == "br" ? "Origem" : "Origin";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.documento") {
      return this.translate.currentLang == "br" ? "CPF/CNPJ" : "EN/SSN";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.email") {
      return "Email";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.ddd") {
      return "DDD";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.telefone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Telephone";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.tiposervicoOrdem") {
      return this.translate.currentLang == "br" ? "Tipo de Serviço/Ordem" : "Type of Service/Order";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.numeroOs") {
      return this.translate.currentLang == "br" ? "Número da OS" : "Order Number";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.km") {
      return "Km";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.numeroChassi") {
      return this.translate.currentLang == "br" ? "Número do Chassi" : "Chassis Number";
    }
    if (item == "businessIntelligence.monitoramentoPrecos.descModelo") {
      return this.translate.currentLang == "br" ? "Descrição do modelo" : "Model description";
    }

  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.origem.value,
      this.f.partNumber.value, this.f.documento.value, this.f.percentual.value, this.f.original.value).subscribe(dados => {
        registros = dados.precos;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          dados.data = dados.data.substring(0, 10);
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          this.exportExcelService.colunasFormatacao = [8];
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }

  private preencherPercentual() {
    this.percentual = [
      { descricao: 'Maior/Igual que 100%', id: "1" },
      { descricao: 'Menor que 100%', id: "2" },
    ];
  }

  public ordenarTabela(event: any) {
    this.dealersDados.sort((a, b) => {
      let campo_a = a[event.field];
      let campo_b = b[event.field];

      if (campo_a > campo_b) return -1;
      if (campo_a < campo_b) return 1;

      return 0;
    });
  }

}
